export const SLIDES_PER_VIEW_MOBILE_MODULE = 2.05

export const SLIDES_PER_VIEW_MOBILE_HORIZONTAL = 1.05

export const SLIDES_PER_VIEW_MOBILE_VERTICAL = 2.05

export const SLIDES_PER_GROUP_MOBILE_MODULE = 2

export const SLIDES_PER_GROUP_MOBILE_HORIZONTAL = 1

export const SLIDES_PER_GROUP_MOBILE_VERTICAL = 2

export const TWO = 2

export const FRACTION_TO_SHOW_NEXT_CARD = 1.0

export const SLIDES_PER_PAGE_DEFAULT = 5
